import { render, staticRenderFns } from "./CardReaderAdd.vue?vue&type=template&id=64d64b55&scoped=true"
import script from "./CardReaderAdd.vue?vue&type=script&lang=ts"
export * from "./CardReaderAdd.vue?vue&type=script&lang=ts"
import style0 from "./CardReaderAdd.vue?vue&type=style&index=0&id=64d64b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d64b55",
  null
  
)

export default component.exports